export const ProfileMenu = Object.freeze({
    MENU: "MENU",
    MY_DATA: "MY_DATA",
});